import { gql } from "@apollo/client";

export const GET_ALL_ELIGIBILITY_BY_ORGANIZATION = gql`
  query GetAllEligibilityByOrgId($orgId: String!) {
    getAllEligibilityByOrgId(orgId: $orgId) {
      id
      orgId
      service {
        id
        orgId
        name
        status
        alternateName
        description
        url
        email
        interpretationServices
        applicationProcess
        waitTime
        cost
        accreditations
        licenses
        subOpCategory
        opCategory
        requiredDocuments
        paymentsAccepted
        eligibilities
        fundings
        serviceAreas
        languages
        # draft
        isPublished
        createdAt
        updatedAt
        overallCapacity
        currentlyServing
        autoScreen
      }
      situation
      autoScreen
    }
  }
`;
